'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _api = require('./api/api.js');

var _api2 = require('./mock/api.js');

var _dateFns = require('date-fns');

var _order = require('./utils/order');

var _order2 = require('./constants/order');

var _time = require('./utils/time');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EXTRA_NODE_CODE = {
  PLATEFORM_CREATED: 10000,
  PLATEFORM_CONFIRM: 10001,
  EXCHANGE: 10002
};

var DISPATCH_TYPES = {
  1: '人工调度',
  2: '智能调度',
  3: '快速取餐',
  4: '抢单大厅'
};

exports.default = {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    trackingId: {
      type: String,
      default: ''
    },
    mock: {
      type: Boolean,
      default: false
    },
    dataPath: {
      type: String,
      default: 'data.data'
    }
  },

  name: 'ElOrderDialog',
  componentName: 'ElOrderDialog',

  data: function data() {
    return {
      exceptionReasonOptions: [],
      exceptionReason: '',
      customReason: '',
      exceptionType: '',
      order: {
        shoppingCart: {}
      },
      reasonMap: {
        '-100': [{
          value: '-102',
          label: '餐厅不出餐'
        }],
        '-200': [{
          value: '-203',
          label: '用户地址错误'
        }, {
          value: '-201',
          label: '用户不接电话'
        }],
        '-300': [{
          value: '-302',
          label: '无法配送'
        }]
      },
      isDeliverying: false,
      exceptionPopover: {
        visible: false
      },
      activeOrderStep: 1
    };
  },


  computed: {
    statusIcon: function statusIcon() {
      var _statusAndClassMap;

      var statusAndClassMap = (_statusAndClassMap = {}, (0, _defineProperty3.default)(_statusAndClassMap, _order2.ORDER_STATUS.ACCEPT, 'arrive-store'), (0, _defineProperty3.default)(_statusAndClassMap, _order2.ORDER_STATUS.ASSIGN, 'arrive-store'), (0, _defineProperty3.default)(_statusAndClassMap, _order2.ORDER_STATUS.ARRIVAL, 'take-food'), (0, _defineProperty3.default)(_statusAndClassMap, _order2.ORDER_STATUS.FETCH, 'delivery'), (0, _defineProperty3.default)(_statusAndClassMap, _order2.ORDER_STATUS.COMPLETE, 'complete'), (0, _defineProperty3.default)(_statusAndClassMap, _order2.ORDER_STATUS.FAIL, 'unusual'), (0, _defineProperty3.default)(_statusAndClassMap, _order2.ORDER_STATUS.EXCEPTION, 'unusual'), _statusAndClassMap);
      return 'status--' + statusAndClassMap[this.order.state];
    },
    isAllowedMarkException: function isAllowedMarkException() {
      // 待指派 / 待到店 / 待取餐 / 配送中允许标记异常
      return this.order.state === 10 || this.order.state === 20 || this.order.state === 80 || this.order.state === 30;
    }
  },

  filters: {
    orderStatus: function orderStatus(value) {
      return (0, _order.orderStatus)(value.state).label;
    },
    paymentType: function paymentType(value) {
      var types = {
        1: '线下结算',
        2: '在线结算'
      };

      return types[value];
    },
    predictTime: function predictTime(order) {
      return (0, _order.predictTime)(order);
    },
    predictTimeLabel: function predictTimeLabel(order) {
      return (0, _order.isBookedOrder)(order) ? '预定送达' : '期望送达';
    }
  },

  mounted: function mounted() {
    this.isDeliverying = [_order2.ORDER_STATUS.FETCH].indexOf(this.order.status) >= 0;
  },


  methods: {
    openMarkExceptionClickHandler: function openMarkExceptionClickHandler() {
      this.customReason = '';
      this.exceptionReason = '';
      this.exceptionType = '';
    },
    exceptionTypeChangeHandler: function exceptionTypeChangeHandler() {
      this.exceptionReasonOptions = this.reasonMap[this.exceptionType];
      this.exceptionReason = '';
    },
    overtime: function overtime(value) {
      return (0, _order.overtime)(value).html;
    },
    _nodeNameRender: function _nodeNameRender(state, isExchange) {
      var name = '';

      switch (state) {
        case EXTRA_NODE_CODE.PLATEFORM_CREATED:
          name = '下单';
          break;
        case EXTRA_NODE_CODE.PLATEFORM_CONFIRM:
          name = '商户接单';
          break;
        case EXTRA_NODE_CODE.EXCHANGE:
          name = '更换骑手';
          break;
        case _order2.ORDER_STATUS.ASSIGN:
          name = '指派';
          break;
        case _order2.ORDER_STATUS.ARRIVAL:
          name = '到店';
          break;
        case _order2.ORDER_STATUS.FETCH:
          name = '取餐';
          break;
        case _order2.ORDER_STATUS.EXCEPTION:
        case _order2.ORDER_STATUS.FAIL:
          name = '异常';
          break;
        case _order2.ORDER_STATUS.CANCEL:
          name = '订单取消';
          break;
        case _order2.ORDER_STATUS.COMPLETE:
          name = '送达';
          break;
        case _order2.ORDER_STATUS.CREATE:
          name = '呼单';
          break;
        case _order2.ORDER_STATUS.ACCEPT:
          name = '团队接单';
          break;
        default:
          break;
      }

      if (isExchange) {
        name = '更换骑手';
      }

      return name;
    },


    // - 下单
    // - 商户接单
    // - 呼单
    // - 指派
    // ...
    _recomposeNode: function _recomposeNode(order) {
      var _this = this;

      var nodes = [];
      var activeNodeIndex = -1;
      var lastState = _order2.ORDER_STATUS.ACCEPT;
      var newNode = {};

      // 补全前缀节点 - start
      // [下单]
      newNode = {
        name: this._nodeNameRender(EXTRA_NODE_CODE.PLATEFORM_CREATED),
        duration: '',
        updateTimeQuene: [{
          time: order.platformCreatedTime,
          name: ''
        }],
        state: EXTRA_NODE_CODE.PLATEFORM_CREATED
      };
      nodes.push(newNode);
      activeNodeIndex++;

      // [商户接单]
      newNode = {
        name: this._nodeNameRender(EXTRA_NODE_CODE.PLATEFORM_CONFIRM),
        duration: '',
        updateTimeQuene: [{
          time: order.platformConfirmTime,
          name: ''
        }],
        state: EXTRA_NODE_CODE.PLATEFORM_CONFIRM
      };
      nodes.push(newNode);
      activeNodeIndex++;
      // 补全前缀节点 - end
      // 补全中间节点 - start
      order.orderEvents.forEach(function (node, index) {
        var prevNode = order.orderEvents[index - 1];
        newNode = {
          name: _this._nodeNameRender(node.state),
          duration: '',
          updateTimeQuene: [{
            time: node.ocurredTime,
            name: ''
          }],
          state: node.state,
          assignType: node.assignType,
          carrierDriverId: node.carrierDriverId,
          isExchange: false
        };
        var isNewNode = false;

        // 指派阶段
        if (prevNode) {
          if (prevNode.state === node.state && !prevNode.isExchange) {
            // 新节点为交换骑手节点
            // 比如：[下单] -> [交换骑手]
            // newNode.state = EXTRA_NODE_CODE.EXCHANGE;
            node.isExchange = true;
            newNode.isExchange = true;

            newNode.updateTimeQuene = [{
              time: prevNode.ocurredTime,
              name: prevNode.carrierDriverName
            }];
            newNode.updateTimeQuene.push({
              time: node.ocurredTime,
              name: node.carrierDriverName
            });

            isNewNode = true;
          } else if (!prevNode.isExchange && prevNode.state !== node.state) {
            // 新旧节点都非交换骑手节点
            // 比如：[下单] -> [呼单]
            newNode.state = newNode.state;

            isNewNode = true;
          } else if (prevNode.isExchange && prevNode.state === node.state) {
            // 新旧节点均为交换骑手节点，合并节点
            // 比如：[下单] -> [交换骑手] -> [交换骑手] 合并成 [下单] -> [交换骑手]
            nodes[nodes.length - 1].updateTimeQuene.push({
              time: node.ocurredTime,
              name: node.carrierDriverName
            });
            node.isExchange = true;
            newNode.isExchange = true;
          } else {
            isNewNode = true;
          }
        } else {
          isNewNode = true;
        }

        if (isNewNode) {
          if (newNode.state !== _order2.ORDER_STATUS.FAIL && newNode.state !== EXTRA_NODE_CODE.EXCHANGE) {
            lastState = newNode.state;
          }
          nodes.push(newNode);
          activeNodeIndex++;
        }
      });
      // 补全中间节点 - end

      // 补全后缀节点 - start
      var normalOrderQuene = [_order2.ORDER_STATUS.CREATE, _order2.ORDER_STATUS.ACCEPT, _order2.ORDER_STATUS.ASSIGN, _order2.ORDER_STATUS.ARRIVAL, _order2.ORDER_STATUS.FETCH, _order2.ORDER_STATUS.COMPLETE];

      var normalOrderQueneLen = normalOrderQuene.length;
      var normalIndex = normalOrderQueneLen - 1;

      for (var i = 0; i < normalOrderQueneLen; i++) {
        if (normalOrderQuene[i] === lastState) {
          normalIndex = i;
          break;
        }
      }

      normalOrderQuene = normalOrderQuene.slice(normalIndex + 1);

      normalOrderQuene.forEach(function (item) {
        var newNode = {
          state: item
        };

        nodes.push(newNode);
      });
      // 补全后缀节点 - end

      // 统一处理
      nodes = nodes.map(function (node, index) {
        var prevNode = nodes[index - 1];
        var duration = '';

        // 计算时间间隔
        if (prevNode) {
          var prevTimeQueneLen = prevNode.updateTimeQuene ? prevNode.updateTimeQuene.length : 0;
          var nextTimeQueneLen = node.updateTimeQuene ? node.updateTimeQuene.length : 0;
          if (prevTimeQueneLen > 0 && nextTimeQueneLen > 0) {
            duration = node.updateTimeQuene[nextTimeQueneLen - 1].time - prevNode.updateTimeQuene[prevTimeQueneLen - 1].time;
            duration = (0, _time.durationFormat)(duration);
          }
        }
        node.duration = duration;
        // 格式化时间节点
        node.updateTimeFormatQuene = !node.updateTimeQuene ? [] : node.updateTimeQuene.map(function (item, index) {
          var nextItem = node.updateTimeQuene[index + 1];

          if (node.isExchange) {
            if (index === node.updateTimeQuene.length - 1) {
              return '<span class="deliveryman-name">' + item.name + '</span>: ' + (0, _dateFns.format)(item.time, 'HH:mm');
            } else if (index !== node.updateTimeQuene.length - 1 && nextItem) {
              return '<span class="deliveryman-name">' + item.name + '</span>: ' + (0, _dateFns.format)(item.time, 'HH:mm') + ' - ' + (0, _dateFns.format)(nextItem.time, 'HH:mm');
            }
          } else {
            return (0, _dateFns.format)(item.time, 'HH:mm');
          }
        }).filter(function (item) {
          return item !== '';
        }).sort(function () {
          return 1;
        });

        node.name = _this._nodeNameRender(node.state, node.isExchange);

        // 待指派节点区分指派方式
        if (node.state === _order2.ORDER_STATUS.ASSIGN && !node.isExchange) {
          node.name = DISPATCH_TYPES[node.assignType] || '指派';
        }
        return node;
      });

      return {
        nodes: nodes,
        activeNodeIndex: activeNodeIndex
      };
    }
  },

  watch: {
    visible: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(val) {
        var res, data, _recomposeNode2, nodes, activeNodeIndex;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.$emit('update:visible', val);

                if (!val) {
                  _context.next = 24;
                  break;
                }

                _context.prev = 2;
                res = '';

                if (!this.mock) {
                  _context.next = 10;
                  break;
                }

                _context.next = 7;
                return (0, _api2.mockFetchOrderDetail)(this.trackingId);

              case 7:
                res = _context.sent;
                _context.next = 13;
                break;

              case 10:
                _context.next = 12;
                return (0, _api.fetchOrderDetail)(this.trackingId);

              case 12:
                res = _context.sent;

              case 13:
                data = res;

                // dataPath: data.data <=> res.data.data

                this.dataPath.split('.').forEach(function (item) {
                  data = data[item];
                });

                _recomposeNode2 = this._recomposeNode(data), nodes = _recomposeNode2.nodes, activeNodeIndex = _recomposeNode2.activeNodeIndex;

                data.$nodes = nodes;
                this.order = data;

                this.activeOrderStep = activeNodeIndex;

                this.$nextTick(function () {
                  // 体验优化，滚动
                  var stepsNode = document.querySelector('.order-steps');
                  stepsNode.scrollLeft = 1000;
                });
                _context.next = 24;
                break;

              case 22:
                _context.prev = 22;
                _context.t0 = _context['catch'](2);

              case 24:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 22]]);
      }));

      function visible(_x) {
        return _ref.apply(this, arguments);
      }

      return visible;
    }()
  },

  render: function render() {
    var _this2 = this;

    var h = arguments[0];

    if (this.order && this.order.$nodes) {
      var steps = this.order.$nodes.map(function (node, $index) {
        var times = node.updateTimeFormatQuene.map(function (time) {
          return h(
            'dd',
            null,
            [h(
              'span',
              null,
              [time]
            )]
          );
        });
        return h(
          'el-step',
          {
            attrs: {
              title: node.name
            },
            'class': 'node ' + (node.state === 90 || node.state === 70 ? 'node--exception' : ''),
            key: $index },
          [h(
            'section',
            { slot: 'description' },
            [h(
              'dl',
              { 'class': 'node__update-time' },
              [times]
            ), h(
              'span',
              { 'class': 'node__duration' },
              [node.duration]
            ), h(
              'span',
              { 'class': 'node__name' },
              [node.name]
            )]
          )]
        );
      });
      var cartItems = this.order.shoppingCart.cartItem.map(function (item) {
        return h(
          'tr',
          null,
          [h(
            'td',
            null,
            [item.name]
          ), h(
            'td',
            null,
            ['\xD7 ', item.quantity]
          ), h(
            'td',
            null,
            [item.weight, 'g']
          ), h(
            'td',
            null,
            ['\uFFE5 ', item.price]
          )]
        );
      });
      var orderTags = this.order.orderTags.map(function (tag) {
        return h(
          'span',
          { 'class': 'order__tag' },
          [tag]
        );
      });
      var orderOverTime = (0, _order.overtime)(this.order);

      var beforeCloseHandler = function beforeCloseHandler(done) {
        _this2.visible = false;
        _this2.$emit('update:visible', false);
        done();
      };

      return h(
        'el-dialog',
        {
          attrs: {
            title: '\u63D0\u793A',
            visible: this.visible,

            'before-close': beforeCloseHandler,
            size: 'large' },
          'class': 'el-order-dialog' },
        [h(
          'header',
          { slot: 'title', 'class': 'dialog-header' },
          [h(
            'i',
            { 'class': this.statusIcon },
            []
          ), h(
            'p',
            { 'class': 'order__status' },
            ['\u8BA2\u5355', this.$options.filters.orderStatus(this.order), ' ', this.order.errorType ? '- ' + this.order.errorType + ', ' + this.order.errorMsg : '', ' ', orderTags]
          ), h(
            'p',
            { 'class': 'order__extra' },
            [h(
              'span',
              { style: { color: orderOverTime.isWarming ? 'red' : '' } },
              [orderOverTime.label]
            ), ' | ', this.$options.filters.predictTimeLabel(this.order), ' : ', (0, _dateFns.format)(this.$options.filters.predictTime(this.order), 'HH:mm:ss'), ' | \u9A91\u624B\uFF1A', this.order.carrierDriverName, ' ', this.order.carrierDriverPhone]
          )]
        ), h(
          'el-steps',
          {
            attrs: { space: 150, active: this.activeOrderStep, 'finish-status': 'success' },
            'class': 'order-steps' },
          [steps]
        ), h(
          'div',
          { 'class': 'order-info' },
          [h(
            'section',
            { 'class': 'order-info__left' },
            [h(
              'section',
              { 'class': 'block delivery__take' },
              [h(
                'i',
                { 'class': 'block__icon el-icon-cm-shop' },
                []
              ), h(
                'header',
                { 'class': 'block__title' },
                ['\u53D6\u9910\u4FE1\u606F']
              ), h(
                'section',
                { 'class': 'block__body' },
                [h(
                  'table',
                  null,
                  [h(
                    'tr',
                    null,
                    [h(
                      'th',
                      null,
                      ['\u5546\u5BB6\u540D\u79F0\uFF1A']
                    ), h(
                      'td',
                      null,
                      [this.order.merchantName]
                    )]
                  ), h(
                    'tr',
                    null,
                    [h(
                      'th',
                      null,
                      ['\u53D6\u9910\u5730\u5740\uFF1A']
                    ), h(
                      'td',
                      null,
                      [this.order.merchantAddress]
                    )]
                  ), h(
                    'tr',
                    null,
                    [h(
                      'th',
                      null,
                      ['\u8054\u7CFB\u7535\u8BDD\uFF1A']
                    ), h(
                      'td',
                      null,
                      [this.order.merchantPhone]
                    )]
                  ), h(
                    'tr',
                    null,
                    [h(
                      'th',
                      null,
                      ['\u5546\u5BB6\u7ED3\u7B97\uFF1A']
                    ), h(
                      'td',
                      null,
                      [this.$options.filters.paymentType(this.order.merchantPaymentType)]
                    )]
                  )]
                )]
              )]
            ), h(
              'section',
              { 'class': 'block delivery__send' },
              [h(
                'i',
                { 'class': 'block__icon el-icon-cm-single' },
                []
              ), h(
                'header',
                { 'class': 'block__title' },
                ['\u9001\u9910\u4FE1\u606F']
              ), h(
                'section',
                { 'class': 'block__body' },
                [h(
                  'table',
                  null,
                  [h(
                    'tr',
                    null,
                    [h(
                      'th',
                      null,
                      ['\u987E\u5BA2\u59D3\u540D\uFF1A']
                    ), h(
                      'td',
                      null,
                      [this.order.customerName || '- -']
                    )]
                  ), h(
                    'tr',
                    null,
                    [h(
                      'th',
                      null,
                      ['\u9001\u9910\u5730\u5740\uFF1A']
                    ), h(
                      'td',
                      null,
                      [this.order.customerAddress || '- -']
                    )]
                  ), h(
                    'tr',
                    null,
                    [h(
                      'th',
                      null,
                      ['\u8054\u7CFB\u7535\u8BDD\uFF1A']
                    ), h(
                      'td',
                      null,
                      [this.order.customerPhone || '- -']
                    )]
                  ), h(
                    'tr',
                    null,
                    [h(
                      'th',
                      null,
                      ['\u7528\u6237\u652F\u4ED8\uFF1A']
                    ), h(
                      'td',
                      null,
                      [this.$options.filters.paymentType(this.order.customerPaymentType)]
                    )]
                  ), h(
                    'tr',
                    null,
                    [h(
                      'th',
                      null,
                      [this.$options.filters.predictTimeLabel(this.order), '\uFF1A']
                    ), h(
                      'td',
                      null,
                      [(0, _dateFns.format)(this.$options.filters.predictTime(this.order), 'HH:mm:ss')]
                    )]
                  )]
                )]
              )]
            )]
          ), h(
            'section',
            { 'class': 'order-info__right' },
            [h(
              'section',
              { 'class': 'block delivery__take' },
              [h(
                'i',
                { 'class': 'block__icon el-icon-cm-ecommerce' },
                []
              ), h(
                'header',
                { 'class': 'block__title' },
                ['\u5546\u54C1\u4FE1\u606F']
              ), h(
                'section',
                { 'class': 'block__body' },
                [h(
                  'section',
                  { 'class': 'goods__detail' },
                  [h(
                    'table',
                    null,
                    [cartItems]
                  )]
                ), h(
                  'section',
                  { 'class': 'goods__summary' },
                  ['\u5171 ', this.order.shoppingCart.shopCount, ' \u4EF6\u5546\u54C1\uFF0C\u5B9E\u4ED8 \uFFE5 ', this.order.shoppingCart.totalAmount]
                ), h(
                  'section',
                  { 'class': 'goods__invoice' },
                  [h(
                    'table',
                    null,
                    [h(
                      'tr',
                      null,
                      [h(
                        'th',
                        null,
                        ['\u5907\u6CE8:']
                      ), h(
                        'td',
                        null,
                        [this.order.shoppingCart.remark]
                      )]
                    ), h(
                      'tr',
                      null,
                      [h(
                        'th',
                        null,
                        ['\u53D1\u7968:']
                      ), h(
                        'td',
                        null,
                        [this.order.shoppingCart.invoiceTitle]
                      )]
                    )]
                  )]
                )]
              )]
            )]
          )]
        )]
      );
    } else {
      return '<div></div>';
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/@ele/lpd-component/lib/components/order-dialog/src/order-dialog.js
// module id = 300
// module chunks = 0